'use strict';

(function ($) {

	// on load get the unique values from the list of images
	var galleryCategories = [];
	var galleryHotels = [];

	$('.gallery__container').each(function () {
		if (galleryCategories.includes($(this).data('gallery-category')) === false && $(this).data('gallery-category') !== '') {
			galleryCategories.push($(this).data('gallery-category'));
		}

		if (galleryHotels.includes($(this).data('gallery-hotel')) === false && $(this).data('gallery-hotel') !== '') {
			galleryHotels.push($(this).data('gallery-hotel'));
		}
	});

	galleryCategories.sort();
	galleryHotels.sort();

	$.each(galleryCategories, function (index, val) {
		$('#gallery-categories').append(new Option(val, val));
	});

	$.each(galleryHotels, function (index, val) {
		$('#gallery-hotels').append(new Option(val, val));
	});

	$('#gallery-categories').change(function () {
		var selected = $(this).find(":selected").val();

		$('.gallery__container').each(function () {

			if ($(this).data('gallery-category') === selected || selected === 'default') {
				$(this).removeClass('category-hidden');
				$(this).parent('.gallery__column--cover').removeClass('category-hidden');
			} else {
				$(this).addClass('category-hidden');
				$(this).parent('.gallery__column--cover').addClass('category-hidden');
			}
		});
	});

	$('#gallery-hotels').change(function () {
		var selected = $(this).find(":selected").val();

		$('.gallery__container').each(function () {

			if ($(this).data('gallery-hotel') === selected || selected === 'default') {
				$(this).removeClass('hotel-hidden');
				$(this).parent('.gallery__column--cover').removeClass('hotel-hidden');
			} else {
				$(this).addClass('hotel-hidden');
				$(this).parent('.gallery__column--cover').addClass('hotel-hidden');
			}
		});
	});
})(jQuery);